<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="createBranchDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Create Branch</div
  >

  <form
    class="flex flex-col"
    [formGroup]="createBranchForm"
    (ngSubmit)="create()"
  >
    <div class="text-s2 mt-8 select-none text-left text-base font-semibold"
      >Repo</div
    >

    <div
      data-cy="createProjectDialogManagedCheckbox"
      class="mt-2 flex h-9 cursor-pointer flex-row items-center"
      (click)="prodOnClick()"
    >
      <div
        class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
        [ngClass]="{
          'bg-m600': targetRepoType === repoTypeEnum.Production
        }"
      >
        <m-check-icon
          *ngIf="targetRepoType === repoTypeEnum.Production"
        ></m-check-icon>
      </div>

      <div class="ml-5 select-none text-base">Production</div>
    </div>

    <div
      data-cy="createProjectDialogGitCloneCheckbox"
      class="mt-5 flex h-9 cursor-pointer flex-row items-center"
      (click)="devOnClick()"
    >
      <div
        class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
        [ngClass]="{
          'bg-m600': targetRepoType !== repoTypeEnum.Production
        }"
      >
        <m-check-icon
          *ngIf="targetRepoType !== repoTypeEnum.Production"
        ></m-check-icon>
      </div>

      <div class="ml-5 select-none text-base">Dev-{{ user?.alias }}</div>
    </div>

    <div class="text-s2 mt-8 select-none text-left text-base font-semibold"
      >Branch name</div
    >

    <input
      autocomplete="off"
      spellcheck="false"
      data-cy="createBranchDialogBranchIdInput"
      class="form-input border-s3 focus:border-m600 mt-2 w-72 rounded"
      [ngClass]="{
        'border-r600':
          createBranchForm.controls['branchId'].invalid &&
          createBranchForm.controls['branchId'].touched
      }"
      formControlName="branchId"
      placeholder="Branch Name"
    />
    <m-validation
      [control]="createBranchForm.controls['branchId']"
    ></m-validation>

    <div class="mt-6 text-base font-semibold">Source branch</div>
    <ng-select
      #createBranchSelect
      [fixNgSelectBottom]="createBranchSelect"
      data-cy="createBranchSelect"
      class="mt-2 w-96 text-base"
      [items]="branchesList"
      [clearable]="false"
      [searchable]="false"
      [(ngModel)]="selectedBranchExtraId"
      (change)="branchChange($event)"
      (keyup.esc)="$event.stopImmediatePropagation(); createBranchSelect.blur()"
      (keyup.enter)="
        $event.stopImmediatePropagation(); createBranchSelect.blur()
      "
      appendTo="body"
      formControlName="fromBranch"
      placeholder="Branches"
      bindLabel="extraName"
      bindValue="extraId"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.extraName }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.extraName }}</div>
      </ng-template>
    </ng-select>

    <div class="mt-9">
      <button
        data-cy="createBranchDialogCreateButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Create</button
      >

      <button
        data-cy="createBranchDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>

<div *ngIf="nav$ | async"></div>
<div *ngIf="user$ | async"></div>
